import React, { useState } from 'react';
import PropTypes from 'prop-types';
import add from '@design-system/Assets/add.svg';
import minus from '@design-system/Assets/minus.svg';

const FaqItem = ({ question, answer, isLastItem }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={isLastItem ? 'border-b' : ''}>
      <button
        className="w-full py-4 md:py-6 px-2 md:px-8 border-t border-neutral-500 hover:bg-gray-100 text-left focus:outline-none"
        onClick={toggleAccordion}
      >
        <div className="flex flex-row justify-between">
          <div className="flex flex-row justify-between  w-full items-center">
            <span className="text-orange md:text-xl font-semibold">{question}</span>
            <img src={`${isOpen ? minus : add}`} />
          </div>
          <img
            className={`accordion-icon-open transform transition-transform duration-300 ${
              isOpen ? 'hidden' : ''
            }`}
            src="assets/sella-add.svg"
            alt=""
          />
          <img
            className={`accordion-icon-close transform transition-transform duration-300 ${
              isOpen ? '' : 'hidden'
            }`}
            src="assets/sella-close.svg"
            alt=""
          />
        </div>
      </button>
      <div
        className={`mt-2 pt-6 pb-10 px-4 border-t border-neutral-900 font-light md:text-lg md:px-8 ${
          isOpen ? '' : 'hidden'
        }`}
      >
        {answer}
      </div>
    </div>
  );
};
FaqItem.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
  isLastItem: PropTypes.bool,
};

FaqItem.defaultProps = {
  isLastItem: false,
};
export default FaqItem;
